import { useState } from "react";
import ConfirmModal from "./ConfirmModal";
import CommonModal from "./DumpModal";
import InputField from "./InputField";
import { useUserInfo } from "../../../../../context/user";
import axios from "axios";
import env from "../../../../../config/env";

const LoadURLModal = ({
  isOpen,
  onClose,
  setModal,
  currentSource,
  refetch,
  setRefetch,
}) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newUrl, setNewUrl] = useState("");
  const userActiveLocation = useUserInfo()[4];

  const handleConfirmModal = () => {
    setOpenConfirmModal(!openConfirmModal);
    setModal(false);
  };

  const handleConfirmClick = async () => {
    setLoading(true);
    if (newUrl !== "") {
      try {
        /* 🟢 onboarding API wrapped in try/catch */
        const response = await axios.post(`${BASE_URL}/users/onboarding`, {
          website_url: newUrl,
          profileId: userActiveLocation.id,
          username: userActiveLocation.business_name,
        });
        if (response?.data) {
          setOpenConfirmModal(false);
          setRefetch(!refetch);
        }
      } catch (err) {
        alert(err.message);
        console.log(err);
      }
    }
    setLoading(false);
  };
  return (
    <>
      <CommonModal onClose={onClose} isOpen={isOpen} title="Edit URL">
        <div className="mt-4">
          <label htmlFor="source" className="text-gray-500 text-md">
            Current web address
          </label>
          <InputField
            id="source"
            value={
              currentSource?.website_url || currentSource?.file_name || "form"
            }
            disabled
            classNames="!bg-gray-100 focus:!border-gray-300"
          />

          <div className="mt-4">
            <label htmlFor="new-file" className="text-gray-500 text-md">
              New web address
            </label>
            <InputField
              id="new-file"
              value={newUrl}
              placeholder="Enter new web address"
              onChange={(e) => setNewUrl(e.target.value)}
              classNames="focus:!border-gray-300"
            />
            <button
              className={`mt-4 text-center w-full rounded-md py-3 text-lg ${newUrl
                  ? "bg-black text-white"
                  : "border !border-gray-300 bg-gray-100 text-gray-600"
                }`}
              onClick={handleConfirmModal}
            >
              Next
            </button>
          </div>
        </div>
      </CommonModal>
      <ConfirmModal
        isOpen={openConfirmModal}
        onClose={handleConfirmModal}
        title="Confirm Changes"
        onConfirm={handleConfirmClick}
        loading={loading}
      />
    </>
  );
};

export default LoadURLModal;
